import { useTranslation } from "react-i18next";
import {
  Badge,
  Button,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import React, { useState } from "react";

import { GradeDto } from "../../interfaces";
import { CourseDurationModal } from "../CourseDuration";

type TProps = GradeDto & {
  onEditGrade?: () => void;
  onDeleteGrade?: () => void;
  onSendPushNotification?: () => void;
};
export const Grade: React.FC<TProps> = ({
  id,
  name,
  courseDuration,
  onEditGrade,
  onDeleteGrade,
  onSendPushNotification,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region internal state
  const [showDurationModal, setShowDurationModal] = useState<boolean>(false);
  //#endregion

  //#region handlers
  const onCloseCourseDurationModal = (event: any) => {
    setShowDurationModal(false);
  };

  //#endregion

  return (
    <React.Fragment>
      <Card className="card-body">
        <UncontrolledDropdown direction="end" className="text-end">
          <DropdownToggle tag="a" id="dropdownMenuLink2" role="button">
            <i className="ri-more-fill fs-17"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item edit-list"
              onClick={onEditGrade}
            >
              <i className="ri-pencil-line me-2 align-bottom text-muted"></i>
              {t("edit")}
            </DropdownItem>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item edit-list"
              onClick={onSendPushNotification}
            >
              <i className="ri-notification-line me-2 align-bottom text-muted"></i>
              {t("sendNotification")}
            </DropdownItem>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item remove-list"
              onClick={onDeleteGrade}
            >
              <i className="ri-delete-bin-5-line me-2 align-bottom text-muted"></i>
              {t("delete")}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <div className="d-flex mb-4 align-items-center text-center">
          <div className="flex-grow-1">
            <h4 className="card-title mb-1">
              {i18n.language === "ar" ? name.ar : name.en}
            </h4>
          </div>
        </div>

        <h6 className="mb-3 d-flex justify-content-center">
          {courseDuration &&
            courseDuration.length > 0 &&
            courseDuration[0].sequenceNumber &&
            courseDuration[0].sequenceNumber > 0 && (
              <Badge color={`${"secondary"}`}>
                {courseDuration[0].sequenceNumber}
              </Badge>
            )}
        </h6>
        <Button
          className="btn btn-success btn-sm"
          onClick={() => setShowDurationModal(true)}
        >
          {t("editDuration")}
        </Button>
      </Card>
      <CourseDurationModal
        courseId={courseDuration[0].course?.id}
        gradeId={id}
        show={showDurationModal}
        onCloseClick={onCloseCourseDurationModal}
      />
    </React.Fragment>
  );
};
